<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEmpty, clone } from 'lodash'
  import MultiSelectInput from '@/components/ui/MultiSelectInput'

  export default {
    name: 'SearchFilter',
    components: {
      MultiSelectInput,
    },
    data() {
      return {
        filters: {},
      }
    },
    computed: {
      ...mapState('occasions', ['filterOptions']),
    },
    created() {
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'occasions/RESET_FILTER':
            this.onResetFilter()
            break
          default:
            return false
        }
      })

      if (isEmpty(this.filterOptions)) {
        this.getOccasionFilters()
      }
    },
    methods: {
      ...mapActions('occasions', [
        'resetFilter',
        'getOccasionFilters',
        'updateFilters',
      ]),
      onResetFilter() {
        this.filters = {}
        this.$emit('onResetFilter')
      },
      onResultUpdate(id, args) {
        this.$set(this.filters, id, args)
        this.updateFilters(clone(this.filters))
      },
    },
  }
</script>
